@let currentStatusValue = currentStatus();
@let currentConfigValue = currentConfig();
@let isPreonboarding = currentStatusValue === 'notInvited' && !hasWorkEmail() && hasPersonalEmail();

@if (currentConfigValue.action) {
  <div class="actions">
    <rt-button
      (click)="actionClicked.emit(isPreonboarding ? 'preonboarding' : currentStatusValue)"
      [variant]="currentConfigValue.action.variant"
    >
      <rt-icon [name]="currentConfigValue.action.icon" />
      <span>{{ currentConfigValue.action.text }}</span>
    </rt-button>
  </div>
}
